<template>
  <div class="downtime d-flex align-center justify-center px-12">
    <div class="px-12">
      <img :src="logo" class="rever-logo mb-6" />
      <p
        class="white--text font-size-42 font-bold pa-0 ma-0"
        style="line-height: 45px"
      >
        {{ $t('downtime.title') }}
      </p>
      <p class="blue-grey--text text--lighten-1 body-2 pa-0 ma-0 mt-5">
        {{ $t('downtime.subtitle') }}
      </p>
      <div class="mt-8">
        <p
          class="blue-grey--text text--lighten-1 pa-0 ma-0 body-2"
          style="font-weight: 700;"
        >
          {{ $t('downtime.help_title') }}
        </p>
        <p class="blue-grey--text text--lighten-1 body-2 pa-0 ma-0">
          {{ $t('downtime.help_subtitle') }}
        </p>
      </div>
    </div>
    <img :src="image" class="px-12" />
  </div>
</template>

<script>
import image from '@/assets/images/downtime.png'
import logo from '@/assets/images/logo-rever-text-white.svg'

export default {
  data() {
    return {
      image,
      logo,
    }
  },
}
</script>

<style lang="scss">
.downtime {
  background: $color-blue-grey-darken3 !important;
  height: 100%;
  .rever-logo {
    width: 150px;
    margin: 0px;
    display: block;
  }
}
</style>
